import { Component, OnInit, OnDestroy, Inject, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Store, Action } from '@ngrx/store';
import { Subject } from 'rxjs/Subject';
import { Observable } from 'rxjs/Observable';
import { Router } from '@angular/router';
import { MatDialogRef, MatDialog } from "@angular/material";
import { Actions } from '@ngrx/effects';
import { Subscription } from 'rxjs';
import { MAT_DIALOG_DATA } from '@angular/material';
import * as actions from '../../pillar/dashboard/store/actions';
import { ModuleConfiguration } from '../vocabulary.module.config';
import { AddConceptVersionModel } from "../models/AddConceptVersionModel";
import { UndoDeleteConceptVersionModel } from "../models/UndoDeleteConceptVersionModel";
import { ConceptWorkspaceModel } from "../models/ConceptWorkspaceModel";
import * as dashboardActions from '../../pillar/dashboard/store/actions';
import * as vocabularyActions from '../store/actions';
import * as fromStore from '../store/reducers';
import { AlertsComponent } from '../../pillar/alerts/components/alerts.component';
import { ACTION_ERROR, ActionError } from '../../pillar/common/actions/ActionError';
import { DUPLICATION_FOUND, DuplicationFoundAction } from '../../vocabulary/store/actions/DuplicationFoundAction';

@Component({
  selector: 'brd-duplication-found',
  templateUrl: './duplication-found.component.html',
  styleUrls: ['./duplication-found.component.scss']
})
export class DuplicationFoundComponent implements OnInit, OnDestroy {
  eventUnsubscribe: Subscription;
  errors$: Observable<string[]>;
  destroyed$: Subject<boolean> = new Subject<boolean>();
  undoDeleteActionIdentifier: string;
  @ViewChild(AlertsComponent)
  alerts: AlertsComponent;



  constructor(private store: Store<any>,
    public dialogRef: MatDialogRef<UndoDeleteConceptVersionModel>,
    private formBuilder: FormBuilder,
    private router: Router,
    private actions$: Actions,
    private dialog: MatDialog,
    @Inject(MAT_DIALOG_DATA) public data: UndoDeleteConceptVersionModel) {
  }

  ngOnInit() {
    this.eventUnsubscribe = this.actions$.ofType(vocabularyActions.UNDO_DELETE_CONCEPT_VERSION_SUCCESS)
      //.takeUntil(this.destroyed$)
      .subscribe((a: vocabularyActions.UndoDeleteConceptVersionSuccessAction) => {
        this.router.navigateByUrl('concept-workspace/' + a.payload.restoredConcept.codeSystemVersionKey + '?conceptCode=' + a.payload.restoredConcept.code);
        this.close();
      });

    this.actions$.ofType(ACTION_ERROR)
      .filter((a: ActionError) => this.undoDeleteActionIdentifier && a.payload.action.identifier === this.undoDeleteActionIdentifier)
      .takeUntil(this.destroyed$)
      .subscribe((p: ActionError) => {
        this.undoDeleteActionIdentifier = undefined;
        for (let error in p.payload.errors) {
          if (p.payload.errors.hasOwnProperty(error)) {
            this.alerts.addError(p.payload.errors[error]);
          }
        }

      });
  }

  ngOnDestroy(): void {
    if (this.eventUnsubscribe) {
      this.eventUnsubscribe.unsubscribe();
    }
    this.destroyed$.next(true);
  }

  undoDelete() {
    var model = this.data;
    var undoDeleteAction = new vocabularyActions.UndoDeleteConceptVersionAction({ model: model });
    this.undoDeleteActionIdentifier = undoDeleteAction.identifier;
    this.store.dispatch(new vocabularyActions.UndoDeleteConceptVersionAction({ model: model }));
  }

  close() {
    this.dialogRef.close();
  }
}



// WEBPACK FOOTER //
// ./src/app/vocabulary/components/duplication-found.component.ts